var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    { attrs: { id: "offer_submit" }, on: { submit: _vm.onSubmit } },
    [
      _vm.$currentUser.department == "adkey"
        ? _c(
            "div",
            { staticClass: "alert alert-info", attrs: { role: "alert" } },
            [
              _c("h5", [_vm._v("Правила именования:")]),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n      Вариант А - приложение рекла или веб оффер"),
                _c("br"),
                _vm._v(
                  "\n      Name app [iOS/Android/Web/Nutra/SEO] Geo, например Liga Stavok [iOS] RU\n    "
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n      Вариант Б - оффер из ПП"),
                _c("br"),
                _vm._v(
                  "\n      В самом конце обязательно указываем название партнёрки, например Vulkan [Android] CH – CPABRO\n    "
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n      Вариант В - наше приложение (заводится в CRM Полиной)"
                ),
                _c("br"),
                _vm._v(
                  "\n      [Название ПП] название оффера гео CPA/CPI ставка и валюта, например [Ultra Partners] VegasPlus CH CPA 125eur\n    "
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-12" }, [
          _c("label", [_vm._v("Аффайз ID")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-sm-11" },
          [
            _c(
              "b-form-group",
              [
                _c(
                  "v-select",
                  {
                    attrs: { options: _vm.options, filterable: false },
                    on: { search: _vm.onSearch },
                    scopedSlots: _vm._u([
                      {
                        key: "option",
                        fn: function(option) {
                          return [
                            _c("div", { staticClass: "d-center" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(option.id) +
                                  "\n                            " +
                                  _vm._s(option.title) +
                                  "\n                        "
                              )
                            ])
                          ]
                        }
                      },
                      {
                        key: "selected-option",
                        fn: function(option) {
                          return [
                            _c("div", { staticClass: "selected d-center" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(option.id ? option.id : option.label) +
                                  "\n                        "
                              )
                            ])
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.offer.item.affise_id,
                      callback: function($$v) {
                        _vm.$set(_vm.offer.item, "affise_id", $$v)
                      },
                      expression: "offer.item.affise_id"
                    }
                  },
                  [
                    _c("template", { slot: "no-options" }, [
                      _vm._v(
                        "\n                        Начните вводить ID...\n                    "
                      )
                    ])
                  ],
                  2
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-sm-1 pt-2",
            style: [
              _vm.isMobile
                ? {
                    "padding-left": "15px",
                    "padding-bottom": "10px",
                    "padding-top": "0px !important"
                  }
                : { "padding-left": "0px" }
            ]
          },
          [
            _c(
              "div",
              {
                staticStyle: { cursor: "pointer" },
                attrs: { align: "center" },
                on: {
                  click: function($event) {
                    return _vm.fillFields()
                  }
                }
              },
              [_c("i", { staticClass: "icon-fa icon-fa-refresh" })]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-sm-12" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Аффайз платформа" } },
              [
                _c(
                  "v-select",
                  {
                    attrs: { options: _vm.affisePlatforms },
                    model: {
                      value: _vm.offer.item.affise_platform,
                      callback: function($$v) {
                        _vm.$set(_vm.offer.item, "affise_platform", $$v)
                      },
                      expression: "offer.item.affise_platform"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "no-options" }, slot: "no-options" },
                      [_vm._v("Совпадений не найдено.")]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.submitted && !_vm.offer.item.affise_platform
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v("Выберите Аффайз платформу.")
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Название", "label-for": "title" } },
              [
                _c("b-form-input", {
                  attrs: { id: "title", type: "text" },
                  model: {
                    value: _vm.offer.item.title,
                    callback: function($$v) {
                      _vm.$set(_vm.offer.item, "title", $$v)
                    },
                    expression: "offer.item.title"
                  }
                }),
                _vm._v(" "),
                _vm.submitted && !_vm.offer.item.title
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v("Заполните название.")
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Тип" } },
              [
                _c("v-select", {
                  attrs: {
                    options: _vm.types,
                    searchable: false,
                    required: ""
                  },
                  model: {
                    value: _vm.offer.item.type,
                    callback: function($$v) {
                      _vm.$set(_vm.offer.item, "type", $$v)
                    },
                    expression: "offer.item.type"
                  }
                }),
                _vm._v(" "),
                _vm.submitted && !_vm.offer.item.type
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v("Укажите тип.")
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Гео" } },
              [
                _c(
                  "v-select",
                  {
                    attrs: {
                      options: _vm.countries,
                      required: "",
                      multiple: ""
                    },
                    model: {
                      value: _vm.offer.item.geo,
                      callback: function($$v) {
                        _vm.$set(_vm.offer.item, "geo", $$v)
                      },
                      expression: "offer.item.geo"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "no-options" }, slot: "no-options" },
                      [_vm._v("Совпадений не найдено.")]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.submitted && _vm.offer.item.geo.length === 0
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v("Добавьте страну.")
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Платформа" } },
              [
                _c(
                  "v-select",
                  {
                    attrs: {
                      options: _vm.platforms,
                      required: "",
                      multiple: ""
                    },
                    model: {
                      value: _vm.offer.item.platforms,
                      callback: function($$v) {
                        _vm.$set(_vm.offer.item, "platforms", $$v)
                      },
                      expression: "offer.item.platforms"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "no-options" }, slot: "no-options" },
                      [_vm._v("Совпадений не найдено.")]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.submitted && _vm.offer.item.platforms.length === 0
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v("Добавьте платформу.")
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.$currentUser.department == "agency"
              ? _c(
                  "b-form-group",
                  { attrs: { label: "Вертикаль" } },
                  [
                    _c(
                      "v-select",
                      {
                        attrs: { options: _vm.topics },
                        model: {
                          value: _vm.offer.item.topic,
                          callback: function($$v) {
                            _vm.$set(_vm.offer.item, "topic", $$v)
                          },
                          expression: "offer.item.topic"
                        }
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "no-options" }, slot: "no-options" },
                          [_vm._v("Совпадений не найдено.")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.submitted && !_vm.offer.item.topic
                      ? _c("span", { staticClass: "alert-danger" }, [
                          _vm._v("Заполните вертикаль.")
                        ])
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Рекламодатель" } },
              [
                _c(
                  "v-select",
                  {
                    attrs: {
                      options: _vm.advertisers,
                      reduce: function(advertiser) {
                        return advertiser.value
                      },
                      required: ""
                    },
                    model: {
                      value: _vm.offer.item.advertiser_id,
                      callback: function($$v) {
                        _vm.$set(_vm.offer.item, "advertiser_id", $$v)
                      },
                      expression: "offer.item.advertiser_id"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "no-options" }, slot: "no-options" },
                      [_vm._v("Совпадений не найдено.")]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.submitted && !_vm.offer.item.advertiser_id
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v("Выберите рекламодателя.")
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Трекер" } },
              [
                _c(
                  "v-select",
                  {
                    attrs: { options: _vm.trackers },
                    model: {
                      value: _vm.offer.item.tracker,
                      callback: function($$v) {
                        _vm.$set(_vm.offer.item, "tracker", $$v)
                      },
                      expression: "offer.item.tracker"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "no-options" }, slot: "no-options" },
                      [_vm._v("Совпадений не найдено.")]
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Валюта оффера" } },
              [
                _c(
                  "v-select",
                  {
                    attrs: {
                      options: _vm.currency,
                      searchable: false,
                      required: ""
                    },
                    model: {
                      value: _vm.offer.item.currency,
                      callback: function($$v) {
                        _vm.$set(_vm.offer.item, "currency", $$v)
                      },
                      expression: "offer.item.currency"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "no-options" }, slot: "no-options" },
                      [_vm._v("Совпадений не найдено.")]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.submitted && !_vm.offer.item.currency
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v("Добавьте валюту.")
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "float-right",
                attrs: { type: "submit", variant: "primary" }
              },
              [_vm._v("Сохранить и выйти\n            ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-errors" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f02acaf", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f02acaf","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/front/modals/EditOfferModal.vue
// module id = 908
// module chunks = 0